import React from "react";
import CustomButton from "../../../../../../components/common/buttons/custom-button/custom-button";

const FormHeader = ({ onReset, isEdit, feedName }) => {
    const handleReset = (e) => {
        e.preventDefault(); // Prevent form submission
        onReset();
    };

    return (
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-2">
            <div className="tw-text-[15px] tw-font-semibold">{isEdit ? feedName : "New Custom Feed"}</div>
            <CustomButton
                className="tw-text-[#F69929] tw-bg-white tw-px-2 tw-py-1 tw-text-sm tw-font-semibold hover:tw-underline"
                text="Reset"
                handleClick={handleReset}
                type="button" // Explicitly set type to button
            />
        </div>
    );
};

export default FormHeader;
